import {
    AiFillAlert,
    AiFillFilter,
    AiFillInfoCircle,
    AiFillLayout,
    AiFillPieChart,
    AiFillSetting,
    AiFillUnlock,
    AiOutlineClockCircle,
    AiOutlineUser,
    AiFillCar,
} from 'react-icons/ai';
import {
    BiBarChartSquare,
    BiSearch,
    BiTrafficCone,
    BiHash,
} from 'react-icons/bi';
import { FaInfoCircle, FaUserCog } from 'react-icons/fa';
import {
    FiHash,
    FiServer,
    FiSettings,
    FiUserCheck,
    FiUserPlus,
} from 'react-icons/fi';
import { GiScrew } from 'react-icons/gi';
import { GrUserAdmin } from 'react-icons/gr';
import {
    HiOutlineBackspace,
    HiOutlineCheck,
    HiOutlineDocumentText,
    HiOutlineDotsHorizontal,
    HiOutlineDownload,
    HiOutlinePencil,
    HiOutlinePlus,
    HiOutlineTrash,
    HiOutlineUpload,
    HiOutlineX,
} from 'react-icons/hi';
import { HiOutlineWrenchScrewdriver } from 'react-icons/hi2';
import { IoHammer } from 'react-icons/io5';
import { IconBaseProps, IconType } from 'react-icons/lib';
import { LuCircleDashed } from 'react-icons/lu';
import {
    MdArrowBackIos,
    MdLocationPin,
    MdMonitor,
    MdOutlineCached,
    MdOutlineContentCopy,
    MdWebAsset,
    MdSchedule,
} from 'react-icons/md';
import { RiGitRepositoryPrivateFill } from 'react-icons/ri';
import {
    TbClipboardText,
    TbParking,
    TbProgress,
    TbProgressCheck,
    TbRoad,
} from 'react-icons/tb';
import {
    PiBird,
    PiClockCountdown,
    PiCheckCircle,
    PiCircleDashed,
} from 'react-icons/pi';
import { IconImage } from '@/v1/main/views/Image';

interface Props extends IconBaseProps {
    value?: string | IconType;
}

interface IconMap {
    [key: string]: IconType;
}

export type IconImgType = IconType;
export const IconImg: IconMap = {
    // btn
    HiOutlineDocumentText,
    HiOutlinePlus,
    HiOutlinePencil,
    HiOutlineTrash,
    HiOutlineUpload,
    HiOutlineDownload,
    HiOutlineCheck,
    HiOutlineX,
    HiOutlineBackspace,
    FaInfoCircle,
    RiGitRepositoryPrivateFill,
    GrUserAdmin,
    FiUserPlus,
    FiUserCheck,
    MdOutlineContentCopy,
    MdOutlineCached,
    AiFillUnlock,
    TbProgressCheck,
    TbProgress,

    // menu
    FiHash,
    BiTrafficCone,
    HiOutlineWrenchScrewdriver,
    FiServer,
    TbRoad,
    TbParking,
    TbClipboardText,
    FiSettings,
    MdWebAsset,
    FaUserCog,
    GiScrew,
    BiBarChartSquare,
    MdMonitor,
    AiFillPieChart,
    MdLocationPin,
    // AiFillSetting,
    BiHash,
    AiFillLayout,
    IoHammer,
    MdSchedule,

    // interface
    HiOutlineDotsHorizontal,
    AiFillFilter,
    BiSearch,
    AiOutlineClockCircle,
    MdArrowBackIos,
    AiFillSetting,
    AiOutlineUser,
    AiFillCar,

    AiFillAlert,
    LuCircleDashed,
    AiFillInfoCircle,

    // shift_schedule
    PiBird,
    PiClockCountdown,
    PiCircleDashed,
    PiCheckCircle,
};

export const Icon = ({ value, className, ...rest }: Props) => {
    const Element = typeof value == 'string' ? IconImg[value] : value;
    if (!Element) {
        return <IconImage />;
    }

    if (className) {
        return (
            <div className={className}>
                <Element {...rest} />
            </div>
        );
    } else {
        return (
            <span
                role="img"
                aria-label="poweroff"
                className="anticon anticon-poweroff"
            >
                <Element {...rest} />
            </span>
        );
    }
};
